var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.email)?_c('div',[_c('a',{staticClass:"emailcolumn",attrs:{"href":("mailto:" + _vm.email)},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.email))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }